import { init as initMonitor } from './monitor';
import { bridge } from '@funny/bridge';
import { goTo } from '@funny/goto';
import { openApp } from '@funny/cross-platform';
import { getAppVersion, getGlobalParams, getQuery, getUserId, env, compareVersion, decrypt } from '@funny/env';
import { request, get, post, del, put, setBaseURL, receiveLevelReward, receiveAllLevelReward, setActConfig, getActInfo, getConfig, getExchangeList, getLotteryRecord, getRankList, getRankReward, getRewardPreview, getTaskList, getTaskReward, getUploadSignature, requestExchange, requestLottery, upload, getRuleText, getCollectionList, getActTickets, initActCenter, } from '@funny/request';
import { Router } from '@funny/router';
import { share, invokeShareByManual, initOutsideBar, takeHtmlSnapshoot, saveHtmlElementAs, format, imgUrlToBase64, downloadBase64, downloadBlob, downloadFile, base64ToBlob, base64ToFile, blobToBase64, fileToBase64, getResource, getImageInfo, setTextIntoClipboard, saveToAlbum, normalRankDataAdaptor, } from '@funny/share';
import { track, trackElClick, trackPv, trackElClickH5KTV, trackElClickH5, trackTp, trackInit } from '@funny/track';
import { upgrade } from './upgrade';
export { bridge, openApp, goTo, getAppVersion, getGlobalParams, getQuery, getUserId, env, decrypt, request, get, post, del, put, setBaseURL, receiveLevelReward, receiveAllLevelReward, getActInfo, getConfig, getExchangeList, getLotteryRecord, getRankList, getRankReward, getRewardPreview, setActConfig, getTaskList, getTaskReward, requestExchange, requestLottery, getUploadSignature, upload, getRuleText, getCollectionList, getActTickets, share, invokeShareByManual, initOutsideBar, takeHtmlSnapshoot, setTextIntoClipboard, saveHtmlElementAs, format, imgUrlToBase64, downloadBase64, downloadBlob, downloadFile, base64ToBlob, blobToBase64, fileToBase64, base64ToFile, track, trackElClick, trackPv, trackElClickH5KTV, trackElClickH5, trackTp, trackInit, compareVersion, getResource, getImageInfo, saveToAlbum, normalRankDataAdaptor, Router, };
/**
 * 此方法可能会因为用户的app版本过低抛出错误，若接管错误请手动处理后续的阻断渲染逻辑
 * @param monitor 奥特曼需要显式的不初始化监控
 */
export function init(monitor) {
    if (monitor === void 0) { monitor = true; }
    // 在保证升级校验通过的情况下才初始化monitor，否则会增加额外的错误
    upgrade();
    monitor && initMonitor();
}
export function initActConfig(_a) {
    var showInActCenter = _a.showInActCenter, actId = _a.actId, memberId = _a.memberId, levelIds = _a.levelIds, lotteryIds = _a.lotteryIds, exchangeIds = _a.exchangeIds, collectionIds = _a.collectionIds;
    var response;
    if (showInActCenter) {
        response = initActCenter(actId);
    }
    // 设置全局的配置
    setActConfig({
        actId: actId,
        memberId: memberId,
        levelIds: levelIds,
        lotteryIds: lotteryIds,
        exchangeIds: exchangeIds,
        collectionIds: collectionIds,
    });
    return response;
}
